import { useState, useEffect } from 'react';
import { getCompanies } from '../api/companies';
import { Company, PaginatedResponse, ListParams } from '../types/index';

interface UseCompaniesReturn {
  companies: Company[];
  total: number;
  isLoading: boolean;
  error: Error | null;
  refetch: (params?: ListParams) => Promise<void>;
}

export const useCompanies = (params?: ListParams): UseCompaniesReturn => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const refetch = async (newParams?: ListParams) => {
    setIsLoading(true);
    setError(null);

    try {
      const data: PaginatedResponse<Company> = await getCompanies(newParams || params);
      setCompanies(data.items);
      setTotal(data.total);
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to fetch companies');
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    refetch();
  }, [params]);

  return { companies, total, isLoading, error, refetch };
};

// Bug #331: this was `// API call stub` returning `Promise.resolve()`, so
// the Add company modal closed as though it had saved and nothing was ever
// created. Re-exported from the API module rather than reimplemented, so
// there is one code path and callers keep importing from where they already
// did. (`useProjects.ts` still carries the identical stub — raised
// separately; the projects create form additionally needs a client picker.)
export { createCompany, updateCompany, deactivateCompany } from '../api/companies';
